export type RemoveItemSource = any;

type TryRemoveFromMailStoreItemsFunction = (itemIdToRemove: string, removeItemSource: RemoveItemSource, skipMutator?: boolean) => void;

type IsMailStoreItemHeldFunction = (itemId: string, removeItemSource: RemoveItemSource) => boolean;

let tryRemoveFromMailStoreItemsFunc: TryRemoveFromMailStoreItemsFunction | null = null;
let isMailStoreItemHeldFunc: IsMailStoreItemHeldFunction | null = null;

export function setTryRemoveFromMailStoreItemsFunction(func: TryRemoveFromMailStoreItemsFunction): void {
    tryRemoveFromMailStoreItemsFunc = func;
}

export function setIsMailStoreItemHeldFunction(func: IsMailStoreItemHeldFunction): void {
    isMailStoreItemHeldFunc = func;
}

export default function tryRemoveFromMailStoreItems(itemIdToRemove: string, removeItemSource: RemoveItemSource, skipMutator?: boolean): void {
    if (!tryRemoveFromMailStoreItemsFunc) {
        throw new Error("tryRemoveFromMailStoreItemsFuncNotSet");
    }
    tryRemoveFromMailStoreItemsFunc(itemIdToRemove, removeItemSource, skipMutator);
}

/**
 * True if the item is still referenced by something other than the caller's own source (e.g. a
 * list view table row, an open conversation, or the item reading pane), meaning
 * {@link tryRemoveFromMailStoreItems} would no-op for it right now. Callers that are about to do
 * destructive/expensive work in anticipation of a removal (e.g. decompressing a cached body) should
 * check this first so they don't do that work for an item that will not actually be removed.
 */
export function isMailStoreItemHeld(itemId: string, removeItemSource: RemoveItemSource): boolean {
    if (!isMailStoreItemHeldFunc) {
        throw new Error("isMailStoreItemHeldFuncNotSet");
    }
    return isMailStoreItemHeldFunc(itemId, removeItemSource);
}
